"use client";

import { NativeSelect } from "@/components/ui/native-select";
import { useTheme } from "@/components/ui/theme-provider";
import { parseTheme, THEMES, THEME_LABELS } from "@/lib/theme";

export function ThemeSelector() {
  const { theme, setTheme } = useTheme();
  return (
    <label className="mt-1 flex min-h-11 items-center justify-between gap-2 rounded-md px-2 text-xs font-medium text-spark-gray">
      <span className="flex items-center gap-2">
        <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="shrink-0">
          <circle cx="12" cy="12" r="8" />
          <path d="M12 4a8 8 0 0 1 0 16Z" fill="currentColor" stroke="none" />
        </svg>
        Theme
      </span>
      <NativeSelect
        aria-label="Color theme"
        value={theme}
        onChange={(event) => setTheme(parseTheme(event.target.value))}
        className="min-h-10 w-36 cursor-pointer rounded-md border-0 bg-transparent pl-2 text-xs font-medium text-spark-charcoal transition-colors hover:bg-spark-hover focus-visible:bg-spark-hover"
      >
        {THEMES.map((value) => (
          <option key={value} className="bg-spark-surface text-spark-charcoal" value={value}>{THEME_LABELS[value]}</option>
        ))}
      </NativeSelect>
    </label>
  );
}
